import React from 'react'
import { FormsContainer } from '../StyledComponents'
import Checklist from './Checklist'
import Feedback from './Feedback'

function Forms() {
	return (
		<FormsContainer>
			<Checklist />
			<Feedback />
		</FormsContainer>
	)
}

export default Forms
